import { render, staticRenderFns } from "./RgbDisplay.vue?vue&type=template&id=3b5051a4&scoped=true"
import script from "./RgbDisplay.vue?vue&type=script&lang=js"
export * from "./RgbDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5051a4",
  null
  
)

export default component.exports